<ion-app>
  <ng-container *ngIf="this.isHeaderLoading$ | async as isHeaderLoading">
    <monorepo-loader-app [isLoading]="isHeaderLoading"></monorepo-loader-app>
  </ng-container>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
